import { useEffect, useState } from 'react'
import useAuthStore from '../stores/Auth'

export const useIsSecurityUserWithLoading = () => {
  const [isSecurityUser, setIsSecurityUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const state = useAuthStore((state) => state)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await state.isSecurityUser()
        setIsSecurityUser(result)
      } catch (error) {
        console.error('Error fetching isSecurityUser:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [state])

  return { isSecurityUser, loading }
}
